import { render, staticRenderFns } from "./devicesTable.vue?vue&type=template&id=53cba531&"
import script from "./devicesTable.vue?vue&type=script&lang=js&"
export * from "./devicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports